import { createSlice } from "@reduxjs/toolkit";

const initialexportXLSModalState = { data: {}, isOpen: false }

const exportXLSModalSlice = createSlice({
    name: 'export_xls_modal',
    initialState: initialexportXLSModalState,
    reducers: {
        openModal(state, action) {
            state.data = action.payload
            state.isOpen = true
        },
        closeModal(state, action) {
            state.data = {}
            state.isOpen = false
        }
    }
})

export const exportXLSModalActions = exportXLSModalSlice.actions;
export default exportXLSModalSlice